import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      gcTime: 24 * 3600_000,
      retry: (n, err) => !(err instanceof ApiError && err.status < 500) && n < 2,
      refetchOnWindowFocus: true,
      networkMode: 'offlineFirst',
    },
    mutations: { networkMode: 'offlineFirst' },
  },
});

/** Chaves de cache (10.1). Toda mutação invalida ['today'] e a chave da própria tela. */
export const qk = {
  me: ['me'] as const,
  today: (date?: string) => (date ? (['today', date] as const) : (['today'] as const)),
  meals: (date: string) => ['meals', date] as const,
  stock: ['stock'] as const,
  water: (date: string) => ['water', date] as const,
  workout: (date: string) => ['workout', date] as const,
  run: ['run'] as const,
  study: ['study', 'today'] as const,
  studyWeek: (start: string) => ['study', 'week', start] as const,
  studyStats: ['study', 'stats'] as const,
  cards: (lang: string) => ['cards', lang] as const,
  cardsQueue: (lang: string) => ['cards-queue', lang] as const,
  progress: ['progress'] as const,
  history: (date: string) => ['history', date] as const,
  historyMonth: (month: string) => ['history', 'month', month] as const,
  alerts: ['alerts'] as const,
  plan: ['plan'] as const,
  settings: ['settings'] as const,
  languages: ['languages'] as const,
  alertRules: ['alert-rules'] as const,
};

export function invalidateToday(extra: readonly (readonly unknown[])[] = []) {
  void queryClient.invalidateQueries({ queryKey: ['today'] });
  void queryClient.invalidateQueries({ queryKey: ['alerts'] });
  for (const k of extra) void queryClient.invalidateQueries({ queryKey: k as unknown[] });
}
